const DEFAULT_LIFE_EXPECTANCY_YEARS = 80;

export interface LifeProportions {
  livedYears: number;
  remainingYears: number;
}

export function calculateLifeProportions(
  ageYears: number,
  lifeExpectancyYears: number = DEFAULT_LIFE_EXPECTANCY_YEARS,
): LifeProportions {
  const livedYears = Math.min(Math.max(0, ageYears), lifeExpectancyYears);
  return {
    livedYears,
    remainingYears: lifeExpectancyYears - livedYears,
  };
}
